<template>
  <div class="main relatorios">
    <c-panel title="Relatórios de Merenda (PNAE)" titleIcon="far fa-file-alt">
      <el-form label-position="top">
        <el-row :gutter="10" class="u-mt-10">
          <el-col :xs="24" :sm="18" :md="18">
            <el-form-item label="Instituição" v-if="$store.state.user.tipo == 10 || ($store.state.user.tipo > 3 && $store.state.user.tipo <= 8)">
              <el-select ref="instituicao_id" v-model="filtro.instituicao_id" filterable placeholder="Pesquisar Instituição" clearable>
                <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <div class="style-form" v-if="$store.state.user.tipo <= 3 || $store.state.user.tipo == 9">
              <label class="el-form-item__label">Instituição</label>
              <div class="style-input readonly">{{ $store.state.config.instituicao.nome }}</div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Ano (custo/aluno)" key="ano">
              <el-input v-model="filtro.ano" maxlength="4" placeholder="ex: 2026"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="16" :md="16">
            <el-form-item label="Relatório" key="relatorio">
              <el-select v-model="relatorioSelected" placeholder="Selecione" filterable>
                <el-option label="CONSUMO POR PERÍODO" value="consumo_periodo"></el-option>
                <el-option label="ESTOQUE ATUAL" value="estoque_atual"></el-option>
                <el-option label="ENTRADAS E SAÍDAS" value="entradas_saidas"></el-option>
                <el-option label="FORNECEDORES (AGRICULTURA FAMILIAR 30%)" value="fornecedores_af30"></el-option>
                <el-option label="CUSTO POR ALUNO" value="custo_aluno"></el-option>
                <el-option label="RASTREABILIDADE" value="rastreabilidade"></el-option>
                <el-option label="ADEQUAÇÃO NUTRICIONAL (PNAE)" value="adequacao_nutricional"></el-option>
                <el-option label="DIETA ESPECIAL / CONFORMIDADE" value="dieta_especial"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8" v-if="relatorioSelected === 'adequacao_nutricional'">
            <el-form-item label="Modalidade (PNAE)" key="modalidade">
              <el-select v-model="filtro.modalidade" clearable>
                <el-option label="CRECHE" value="creche"></el-option>
                <el-option label="PRÉ-ESCOLA" value="pre"></el-option>
                <el-option label="FUNDAMENTAL" value="fundamental"></el-option>
                <el-option label="EJA" value="eja"></el-option>
                <el-option label="INTEGRAL" value="integral"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Data inicial" key="data_inicio">
              <el-date-picker v-model="filtro.data_inicio" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" placeholder="Selecione"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Data final" key="data_fim">
              <el-date-picker v-model="filtro.data_fim" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" placeholder="Selecione"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item label="Alimento (rastreabilidade)" key="alimento_id">
              <el-select v-model="filtro.alimento_id" placeholder="pesquisar" filterable remote clearable :remote-method="searchAlimento" :loading="loadingAlimento">
                <el-option v-for="a in alimentos" :key="a.id" :label="a.nome" :value="a.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" class="u-text-right u-mt-10">
            <el-button @click="baixar('pdf')" :loading="loadingPdf" type="primary">PDF</el-button>
            <el-button @click="baixar('excel')" :loading="loadingExcel" type="primary" plain>EXCEL</el-button>
          </el-col>
        </el-row>
      </el-form>
    </c-panel>
  </div>
</template>

<script>
export default {
  components: {
    cPanel: () => import('@/shared/c-panel/c-panel.vue'),
  },
  data: () => ({
    relatorioSelected: 'consumo_periodo',
    loadingPdf: false,
    loadingExcel: false,
    loadingAlimento: false,
    alimentos: [],
    filtro: {
      instituicao_id: '',
      ano: '',
      data_inicio: '',
      data_fim: '',
      alimento_id: '',
      modalidade: ''
    }
  }),
  mounted () {
    if (this.$store.state.user.tipo <= 3 || this.$store.state.user.tipo == 9) {
      this.filtro.instituicao_id = this.$store.state.config.instituicao.id
    }
    this.filtro.ano = String((new Date()).getFullYear())
  },
  methods: {
    searchAlimento (query) {
      if (!query || query.length < 2) { this.alimentos = []; return }
      this.loadingAlimento = true
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/alimento/searchByNome`, { query }, this.$store.getters.getHeaderAuth)
        .then(res => { this.alimentos = JSON.parse(JSON.stringify(res.data)); this.loadingAlimento = false })
        .catch(e => { this.loadingAlimento = false; this.$store.commit('throwException', e) })
    },
    validateFiltro () {
      if (!this.filtro.instituicao_id) {
        window.eventBus.$emit('alert', { msg: 'Selecione uma instituição.', type: 'warning' })
        return false
      }
      return true
    },
    montarParams (formato) {
      const params = { formato }
      if (this.filtro.ano) params.ano = this.filtro.ano
      if (this.filtro.data_inicio) params.data_inicio = this.filtro.data_inicio
      if (this.filtro.data_fim) params.data_fim = this.filtro.data_fim
      if (this.filtro.alimento_id) params.alimento_id = this.filtro.alimento_id
      if (this.filtro.modalidade) params.modalidade = this.filtro.modalidade
      return params
    },
    baixar (formato) {
      if (!this.validateFiltro()) return
      const loadingKey = formato === 'pdf' ? 'loadingPdf' : 'loadingExcel'
      this[loadingKey] = true
      const url = `${this.$store.state.config.baseUrlApi}/api/merenda/relatorio/${this.relatorioSelected}/${this.filtro.instituicao_id}`
      const config = Object.assign({}, this.$store.getters.getHeaderAuthExcel, { params: this.montarParams(formato) })
      this.$axios.get(url, config)
        .then(response => {
          this[loadingKey] = false
          const blob = new Blob([response.data], { type: formato === 'pdf' ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const ext = formato === 'pdf' ? 'pdf' : 'xlsx'
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = `${this.relatorioSelected}.${ext}`
          link.click()
          window.URL.revokeObjectURL(link.href)
        })
        .catch(error => { this[loadingKey] = false; this.$store.commit('throwException', error) })
    }
  }
}
</script>
